export default {"src":"/_next/static/media/PAGS.defe2b00.svg","height":18,"width":18};